import { create } from 'zustand';
import { AdminOrganizationLoVResponse } from '@api/generated/portal-be-admin';
import { adminLoVManagementApi } from '@api/api-config.ts';

interface AdminOrganizationDropdownState {
  organizations: AdminOrganizationLoVResponse[];
  loading: boolean;
  error: string | null;
}

interface AdminOrganizationDropdownActions {
  loadInitialOrganizations: () => Promise<void>;
  loadOrganizationById: (organizationId: number) => Promise<AdminOrganizationLoVResponse | null>;
  clearError: () => void;
}

type AdminOrganizationDropdownStore = AdminOrganizationDropdownState & AdminOrganizationDropdownActions;

export const useAdminOrganizationDropdownStore = create<AdminOrganizationDropdownStore>((set, get) => ({
  // State
  organizations: [],
  loading: false,
  error: null,

  loadInitialOrganizations: async () => {
    set({ loading: true, error: null });

    try {
      const response = await adminLoVManagementApi.getOrganizations({});
      set({
        organizations: response.data || [],
        loading: false,
      });
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : 'Chyba při načítání organizací',
        loading: false,
      });
    }
  },

  loadOrganizationById: async (organizationId: number) => {
    set({ loading: true, error: null });
    try {
      // Nejdříve zkusíme najít organizaci v již načtených
      const { organizations } = get();
      const existingOrg = organizations.find(org => org.id === organizationId);
      set({ loading: false });
      return existingOrg ?? null;
    } catch (error) {
      set({
        error: error instanceof Error ? error.message : 'Chyba při načítání organizace',
        loading: false,
      });
      return null;
    }
  },

  clearError: () => {
    set({ error: null });
  },
}));
